import React from "react";
import Layout from "../Layout";
import { useTranslation } from "react-i18next";
import UAEDirhamIcon from "../../utils/UAEDirhamIcon";

function PricingPage() {
  const { t } = useTranslation();

  return (
    <Layout title={t("Pricing.title")}>
      <section className="py-10">
        <div className="max-w-5xl mx-auto px-6 text-center">
          {/* العنوان */}
          <h2 className="text-4xl font-bold mb-12">
            {t("Pricing.subscriptionPlans")}
          </h2>

          {/* البطاقات */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Monthly Plan */}
            <div className="rounded-2xl border justify-between border-gray-200 p-8 flex flex-col shadow-sm">
              <h3 className="text-xl font-semibold mb-4">
                {t("Pricing.monthlyPlanTitle")}
              </h3>
              <p className="text-lg text-gray-500 line-through mt-1">
              <span dir="ltr" className="">
                  <UAEDirhamIcon className="w-4 h-4 inline-block" /> 119
                </span>{" "} /{t("Pricing.perMonth")}
              </p>
              <p className="text-4xl font-bold">
                <span dir="ltr" className="">
                  <UAEDirhamIcon className="w-4 h-4 inline-block" /> 95
                </span>{" "}
                <span className="text-lg font-medium">
                  /{t("Pricing.perMonth")}
                </span>
              </p>

              <ul className="mt-6 space-y-3 text-popover-foreground">
                <li>✔ {t("Pricing.monthlyFeatures.0")}</li>
                <li>✔ {t("Pricing.monthlyFeatures.1")}</li>
                <li>✔ {t("Pricing.monthlyFeatures.3")}</li>
                <li>✔ {t("Pricing.monthlyFeatures.4")}</li>
                <li>✔ {t("Pricing.monthlyFeatures.5")}</li>
              </ul>

              <a
                href="https://wa.me/971528401112?text=Hello%20👋%2C%20I%20am%20interested%20in%20the%20Monthly%20Plan%20on%20TWHMENU.com"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 bg-blue-500 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-600 transition"
              >
                {t("Pricing.chooseMonthly")}
              </a>
            </div>

            {/* Yearly Plan */}
            <div className="rounded-2xl border-2 border-blue-500 p-8 flex flex-col shadow-md relative">
              {/* Best Value Badge */}
              <span className="absolute top-4 right-4 bg-blue-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                {t("Pricing.bestValue")}
              </span>

              <h3 className="text-xl font-semibold mb-4">
                {t("Pricing.yearlyPlanTitle")}
              </h3>

              {/* السعر الشهري */}
              <p className="text-xl text-gray-600">
                <span dir="ltr" className="">
                  <UAEDirhamIcon className="w-4 h-4 inline-block" /> 65
                </span>{" "}
                /{t("Pricing.perMonth")}
              </p>

              {/* السعر الكامل قبل الخصم */}
              <p className="text-lg text-gray-500 line-through mt-1">
                <span dir="ltr" className="">
                  <UAEDirhamIcon className="w-4 h-4 inline-block" /> 1140
                </span>{" "}
                /{t("Pricing.perYear")}
              </p>

              {/* الخصم */}
              <p className="text-sm font-semibold text-green-600 mt-1">
                {t("Pricing.save45")}
              </p>

              {/* السعر النهائي */}
              <p className="text-4xl font-bold mt-2">
                <span dir="ltr" className="">
                  <UAEDirhamIcon className="w-4 h-4 inline-block" /> 780
                </span>
                <span className="text-lg font-medium">
                  /{t("Pricing.perYear")}
                </span>
              </p>

              <ul className=" mt-6 space-y-3 text-popover-foreground">
                <li>✔ {t("Pricing.yearlyFeatures.0")}</li>
                <li>✔ {t("Pricing.yearlyFeatures.1")}</li>
                <li>✔ {t("Pricing.yearlyFeatures.2")}</li>
                <li>✔ {t("Pricing.yearlyFeatures.3")}</li>
                <li>✔ {t("Pricing.yearlyFeatures.4")}</li>
                <li>✔ {t("Pricing.yearlyFeatures.6")}</li>
              </ul>

              <a
                href="https://wa.me/971528401112?text=Hello%20👋%2C%20I%20am%20interested%20in%20the%20Yearly%20Plan%20on%20TWHMENU.com"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 bg-blue-500 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-600 transition"
              >
                {t("Pricing.goYearly")}
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default PricingPage;
